/**
 * This schema represents the Roles a User can have in an Org as stored in supabase
 */
import { object, string, type InferType } from "yup"

export const userOrgsRolesList = ["USER_ADMIN", "SERVICE", "CUSTOMER"] as const

export type UserOrgsRoles = (typeof userOrgsRolesList)[number]
export const UserOrgsRolesSchema = string().oneOf(userOrgsRolesList).defined()
export type UserOrgsRolesDto = InferType<typeof UserOrgsRolesSchema>

export const UserOrgsSchema = object({
  user_id: string().required(),
  org_id: string().required().uuid(),
  role: UserOrgsRolesSchema.defined(),
})
export type UserOrgsDto = InferType<typeof UserOrgsSchema>

// type Prettify<T> = {
//   [K in keyof T]: T[K]
// } & {}
// type ugrDto = Prettify<UserOrgsRolesDto>
// type ugDto = Prettify<UserOrgsDto>
